import { render } from "./AgentDashboardView.vue?vue&type=template&id=3c713b60&scoped=true"
import script from "./AgentDashboardView.vue?vue&type=script&lang=js"
export * from "./AgentDashboardView.vue?vue&type=script&lang=js"

import "./AgentDashboardView.vue?vue&type=style&index=0&id=3c713b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c713b60"]])

export default __exports__